import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

// Importuj swoje globalne komponenty stopki
import Footer from './components/Common/Footer';

// Importuj nowy komponent przycisku
import HomePageButton from './components/Common/HomePageButton';

// Importuj wszystkie swoje strony
import AuthPage from './components/Auth/AuthPage';
import HomePage from './components/HomePage';
import ExamCreationPage from './components/Exam/ExamCreationPage';
import ExamPage from './components/Exam/ExamPage';
import ExamResultPage from './components/Exam/ExamResultPage';
import MyExamsPage from './components/Exam/MyExamsPage';
import ErrorPage from './components/ErrorPage';
import LogoutButton from './components/Common/LogoutButton';

// Importuj nowe komponenty motywu
import { ThemeProvider, useTheme } from './components/contexts/ThemeContext';
import ThemeToggleButton from './components/Common/ThemeToggleButton'; // Będziemy tworzyć ten komponent

function App() {
    return (
        <Router>
            <ThemeProvider> {/* Owinięcie całej aplikacji w ThemeProvider */}
                <AppLayout />
            </ThemeProvider>
        </Router>
    );
}

// Nowy komponent do zarządzania układem i przyciskami
function AppLayout() {
    const location = useLocation();
    const { theme } = useTheme(); // Użyj hooka do pobrania aktualnego motywu

    // Sprawdź, czy aktualna ścieżka to '/home'
    const isHomePage = location.pathname === '/home';
    const isAuthPage = location.pathname === '/login-registration';

    // Lista ścieżek, na których przycisk "Wyloguj" ma się pojawić
    const pathsWithLogoutButton = ['/home'];

    const shouldShowLogoutButton = pathsWithLogoutButton.includes(location.pathname);

    // Pozycjonowanie przycisków, dostosowane do nowego przycisku motywu
    const commonButtonStyle = { position: 'absolute', top: '20px', zIndex: 100 };

    return (
        <div className={`app-layout-wrapper ${theme}`}> {/* Dodanie klasy motywu do wrapper'a */}
            <div style={{ position: 'absolute', top: '20px', right: '30px', display: 'flex', gap: '10px', zIndex: 100 }}>
                {shouldShowLogoutButton && (
                    <LogoutButton />
                )}
            <ThemeToggleButton /> {/* Dodaj przycisk do zmiany motywu */}
            </div>
            {!isHomePage && !isAuthPage && (
                <HomePageButton style={{ ...commonButtonStyle, right: shouldShowLogoutButton ? '140px' : '30px' }} />
            )}

            <div className="app-content-wrapper">
                <Routes>
                    <Route path="/login-registration" element={<AuthPage />} />
                    <Route path="/home" element={<HomePage />} />
                    <Route path="/exam/create" element={<ExamCreationPage />} />
                    <Route path="/exam/current" element={<ExamPage />} />
                    <Route path="/exam/result" element={<ExamResultPage />} />
                    <Route path="/my-exams" element={<MyExamsPage />} />
                    <Route path="/error" element={<ErrorPage />} />
                    <Route path="/" element={<Navigate to="/login-registration" replace />} />
                    <Route path="*" element={<ErrorPage />} />
                </Routes>
            </div>

            <Footer />
        </div>
    );
}

export default App;